import React from 'react';
import { useContactInfo } from '../hooks/useContentful';

const MapSectionFixed = () => {
  const { contactInfo, loading, error } = useContactInfo();

  if (loading) {
    return (
      <section className="py-12 md:py-20 bg-gray-50 relative">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-purple-300 to-transparent"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Title Skeleton */}
          <div className="text-center mb-10 md:mb-16">
            <div className="h-8 md:h-10 bg-gradient-to-r from-purple-200 via-purple-300 to-purple-200 rounded-lg w-64 mx-auto mb-4 animate-shimmer-purple"></div>
            <div className="h-5 md:h-6 bg-gradient-to-r from-purple-100 via-purple-200 to-purple-100 rounded-lg w-96 mx-auto animate-shimmer-purple" style={{ animationDelay: '0.3s' }}></div>
          </div>
          {/* Map and Info Grid Skeleton */}
          <div className="lg:grid lg:grid-cols-2 lg:gap-12">
            {/* Map Skeleton */}
            <div className="mb-10 lg:mb-0">
              <div className="bg-gradient-to-br from-purple-200 via-purple-300 to-purple-200 rounded-2xl h-96 w-full animate-shimmer-purple shadow-lg"></div>
            </div>
            {/* Info Cards Skeleton */}
            <div className="space-y-6">
              {[...Array(3)].map((_, index) => (
                <div key={index} className="bg-white rounded-2xl p-6 shadow-md border border-purple-100" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-gradient-to-br from-purple-400 to-purple-500 rounded-full flex-shrink-0 animate-glow"></div>
                    <div className="ml-4 flex-1 space-y-2">
                      <div className="h-4 bg-gradient-to-r from-purple-200 to-purple-300 rounded w-1/2 animate-shimmer-purple"></div>
                      <div className="h-4 bg-gradient-to-r from-purple-100 to-purple-200 rounded w-3/4 animate-shimmer-purple"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error || !contactInfo) {
    return (
      <section className="py-20 bg-gray-50">
        <div className="text-center text-red-600 text-lg">
          No se pudo cargar la información de contacto. Intenta más tarde.
        </div>
      </section>
    );
  }

const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(contactInfo.address)}&output=embed`;
const whatsappNumber = contactInfo?.whatsappNumber?.replace(/\D/g, ''); 
const encodedMessage = encodeURIComponent(contactInfo?.whatsappMessage || '');
const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;


  
  return (

    
    <section  id="Map" className="py-16 md:py-24 bg-gradient-to-br from-purple-50 via-white to-pink-50 relative overflow-hidden">
       <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-purple-400 to-pink-400 to-transparent"></div>
       
       {/* Decorative elements */}
       <div className="absolute top-20 right-10 w-72 h-72 bg-purple-200/20 rounded-full blur-3xl animate-float"></div>
       <div className="absolute bottom-20 left-10 w-96 h-96 bg-pink-200/15 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        
        <div className="text-center mb-12 md:mb-20 animate-fadeInUp">
          <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="fas fa-map-marker-alt"></i>
            Ubicación
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-800 mb-4 md:mb-6 leading-tight">
            Nuestra <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">Ubicación</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-4xl mx-auto px-4 leading-relaxed">
            Nos ubicamos en una zona accesible las 24 horas para que puedas llegar fácilmente en cualquier emergencia veterinaria.
          </p>
        </div>

        {/* Map Container */}
        <div className="animate-fadeInUp" style={{ animationDelay: '0.6s' }}>
          <div className="bg-white rounded-2xl shadow-xl hover:shadow-2xl overflow-hidden transition-all duration-300">
            {/* Address Info Bar */}
            <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 md:px-6 py-3 md:py-4">
              <div className="flex items-center justify-center">
                <i className="fas fa-map-marker-alt text-base md:text-xl mr-2 md:mr-3"></i>
                <span className="text-sm md:text-lg font-semibold text-center">{contactInfo.address}</span>
              </div>
            </div>

            {/* Map */}
            <div className="relative">
              <iframe
                //src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3284.095039235072!2d-58.4124970848805!3d-34.6025191804595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcc9814187f5d9%3A0xc3f8f1d5d2b7f6e0!2sAv.%20Las%20Mascotas%202450%2C%20CABA!5e0!3m2!1ses-419!2sar!4v1625078400000!5m2!1ses-419!2sar"
                src = {mapSrc}
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Ubicación CEV24 - Clínica de Emergencias Veterinarias"
                className="w-full md:h-[450px]"
              ></iframe>

              {/* Overlay with contact info - hidden on mobile */}
              <div className="hidden md:block absolute top-4 right-4 bg-white bg-opacity-95 backdrop-blur-sm rounded-xl p-4 shadow-lg max-w-xs border border-purple-200">
  <h3 className="font-bold text-purple-700 mb-2 flex items-center">
    <i className="fas fa-hospital-symbol mr-2"></i>
    CEV24
  </h3>
  <div className="space-y-1 text-sm">
    <div className="flex items-center text-gray-700">
      <i className="fas fa-phone text-purple-600 w-4 mr-2"></i>
      <span>{contactInfo.phone}</span>
    </div>
    <div className="flex items-center text-gray-700">
      <i className="fas fa-clock text-purple-600 w-4 mr-2"></i>
      <span>{contactInfo.scheduleMap}</span>
    </div>
  </div>
</div>

            </div>

            {/* Bottom info bar */}
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 px-4 md:px-6 py-3 md:py-4 border-t border-purple-200">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-2 md:gap-0">
                <div className="flex items-center text-gray-600 text-xs md:text-base text-center sm:text-left">
                  <i className="fas fa-car text-purple-600 mr-2"></i>
                  <span>Estacionamiento disponible 24h</span>
                </div>
                <div className="flex items-center text-gray-600 text-xs md:text-base text-center sm:text-left">
                  <i className="fas fa-wheelchair text-purple-600 mr-2"></i>
                  <span>Acceso para personas con discapacidad</span>
                </div>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 md:gap-6 mt-8 md:mt-12 justify-center">
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(contactInfo.address)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-8 md:px-12 py-4 md:py-5 rounded-full font-semibold text-center transition-all duration-500 hover:scale-105 shadow-xl hover:shadow-2xl text-base md:text-lg"
            >
              <i className="fas fa-directions mr-2"></i>
              Cómo llegar
            </a>
            <a
              href={`tel:${contactInfo?.emergencyPhone}`}
              className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-8 md:px-12 py-4 md:py-5 rounded-full font-semibold text-center transition-all duration-500 hover:scale-105 shadow-xl hover:shadow-2xl text-base md:text-lg"
            >
              <i className="fas fa-phone mr-2"></i>
              Llamar ahora
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-[#25D366] to-[#128C7E] hover:from-[#128C7E] hover:to-[#25D366] text-white px-8 md:px-12 py-4 md:py-5 rounded-full font-semibold text-center transition-all duration-500 hover:scale-105 shadow-xl hover:shadow-2xl text-base md:text-lg"
            >
              <i className="fab fa-whatsapp mr-2"></i>
              WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSectionFixed;
